export { default } from '@shikijs/langs/jsonl'
